/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs */

const en__field_enum_csjensblank_zwei_mal_pro_monat26 = /** @type {(inputs: _Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`twice a month`)
};

const de__field_enum_csjensblank_zwei_mal_pro_monat26 = /** @type {(inputs: _Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zwei mal im Monat`)
};

/**
* | output |
* | --- |
* | "twice a month" |
*
* @param {_Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_zwei_mal_pro_monat26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Zwei_Mal_Pro_Monat26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_zwei_mal_pro_monat26(inputs)
	return de__field_enum_csjensblank_zwei_mal_pro_monat26(inputs)
});
export { _field_enum_csjensblank_zwei_mal_pro_monat26 as "_field_enum_CSJENSBLANK_ZWEI_MAL_PRO_MONAT" }